import { contentGridGql } from '../product_page/contentGridGql.js';
import { imageGridGql } from '../product_page/imageGridGql.js';
import { linksMatrixGql } from '../link_field/linksMatrixGql.js';
import { productHeaderGalleryGql } from '../product_page/productHeaderGalleryGql.js';
import { productHeaderPremiumGql } from '../product_page/productHeaderPremiumGql.js';
import { productHeaderStandardGql } from '../product_page/productHeaderStandardGql.js';
import { productTabCompareGql } from './product_tab/productTabCompareGql.js';
import { productTabContentGql } from './product_tab/productTabContentGql.js';
import { productTabMultiColumnTableGql } from './product_tab/productTabMultiColumnTableGql.js';
import { productTabRelatedGql } from './product_tab/productTabRelatedGql.js';
import { productTabRelatedResourcesGql } from './product_tab/productTabRelatedResourcesGql.js';
import { productTabTableGql } from './product_tab/productTabTableGql.js';
import { relatedProductsGql } from '../product_page/relatedProductsGql.js';
import { textContentCardsStandaloneGql } from '../product_page/textContentCardsStandaloneGql.js';
import { textIconCardGql } from '../product_page/textIconCardGql.js';

const pageGql = /* GraphQL */ `
title
sectionHandle
siteId
uri
... on product_productPage_Entry {
  typeHandle
  productCategories(orderBy: "lft asc") {
    id
    level
    title
    uri
    ... on productCategories_Category {
      breadcrumbLink {
        uri
      }
    }
  }
  productOverviewSubhead
  productOverviewDescription
  productBrochure {
    ... on productBrochures_Asset {
      title
      url
    }
  }
  ${linksMatrixGql()}
  productOverviewGallery {
    ... on productImages_Asset {
      title
      caption
      galleryThumbnail {
        srcset
        srcsetWebp
      }
      galleryEnlarged {
        srcset
        srcsetWebp
      }
    }
    ... on productVideos_Asset {
      title
      caption
      videoId
      videoSource
      galleryThumbnail {
        srcset
        srcsetWebp
      }
      galleryEnlarged {
        srcset
        srcsetWebp
      }
    }
  }
  relatedProducts {
    typeHandle
    title
    uri
    ... on product_productPage_Entry {
      productFeaturedImage {
        ... on productImages_Asset {
          title
          filterSquare {
            srcset
            srcsetWebp
          }
        }
      }
      relatedEntryDescription
    }
  }
  productDisclaimerFootnote{
    ... on disclaimerFootnote_disclaimerFootnote_Entry{
      content:disclaimercontent
    }
  }
}

... on product_productPage2022_Entry {
  typeHandle
  navigationTheme
  pageTheme
  productCategories(orderBy: "lft asc") {
    id
    level
    title
    uri
    ... on productCategories_Category {
      breadcrumbLink {
        uri
      }
    }
  }
  bodyContent2022 {
    ... on bodyContent2022_header_BlockType {
      typeHandle
      productBrand
      productDescription
      productDescriptors
      productModel
      headerCta {
        ... on headerCta_BlockType {
          entry {
            url
          }
          asset {
            url
            ... on videos_Asset {
              videoId
              videoSource
            }
          }
          styling
          openInANewWindow
          custom
          buttonLabel
          ariaLabel
          enableModal
          disclaimerFootnote {
             ... on disclaimerFootnote_disclaimerFootnote_Entry {
                content:disclaimercontent
            }
          }
        }
      }
      gallery {
        ... on images_Asset {
          title
          caption
          galleryThumbnail {
            srcset
            srcWebp
          }
          galleryEnlarged {
            srcset
            srcWebp
          }
        }
        ... on videos_Asset{
          videoId
          videoSource
          galleryThumbnail {
            srcset
            srcWebp
          }
          galleryEnlarged {
            srcset
            srcWebp
          }
        }
      }
      sidebar
      sidebarButton {
        ... on sidebarButton_BlockType {
          entry {
            url
          }
          asset {
            url
          }
          openInANewWindow
          custom
          buttonLabel
          ariaLabel
        }
      }
    }
    ... on bodyContent2022_disclaimerFootnote_BlockType {
      typeHandle
      disclaimerFootnote {
        ... on disclaimerFootnote_disclaimerFootnote_Entry {
          content:disclaimercontent
        }
      }
      colors
    }
    ... on bodyContent2022_chart_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks
      id
      chartColumn {
        columnContent @markdown
        columnHeading
      }
    }
    ... on bodyContent2022_productByTheNumbers_BlockType {
      typeHandle
      pageTitle
      pageDescription
      displayInHeaderQuicklinks
      id
      productByTheNumber {
        ... on productByTheNumber_BlockType {
          label
          unit
          description
          icon {
            ... on svgIcons_Asset {
              url
              title
            }
          }
        }
      }
    }
    ... on bodyContent2022_promo_BlockType {
      typeHandle
      promoEntry {
        typeHandle
        ... on event_eventV2_Entry {
          promoTabStyle
          promoCardStyle
          promoDescription
          promoTitle
          promoImage {
            ... on images_Asset {
              lpImageTextUncropped {
                optimizedImageUrls
                srcset
                srcWebp
              }
              lpImageTextUncropped {
                optimizedImageUrls
              }
            }
          }
          eventFilters {
            ... on eventFilters_Category {
              slug
              title
              parent {
                slug
              }
            }
          }
          eventRecordingUrl
          eventStartDateTime: eventStartDateTime @formatDateTime (format: "D M d Y H:i:s O")
          eventEndDateTime: eventEndDateTime @formatDateTime (format: "D M d Y H:i:s O")
          eventTimezone: eventStartDateTime @formatDateTime (format: "e")
          timezone
          location: eventLocationCityState
          eventPrice
          dateAndTimeDisplay
          linksMatrix2 {
            ... on linksMatrix2_entry_BlockType {
              buttonLabel
              ariaLabel
              entry {
                uri
              }
              openInANewWindow
            }
            ... on linksMatrix2_custom_BlockType {
              ariaLabel
              buttonLabel
              urlText
              openInANewWindow
            }
            ... on linksMatrix2_asset_BlockType {
              ariaLabel
              buttonLabel
              openInANewWindow
              asset {
                uri
              }
            }
            ... on linksMatrix2_productCategory_BlockType {
              ariaLabel
              buttonLabel
              productCategory {
                uri
              }
              openInANewWindow
            }
          }
        }
        ... on whitePaper_whitePaper_Entry {
          promoTabStyle
          promoEyebrow
          promoCardStyle
          promoDescription
          promoTitle
          promoImage {
            ... on images_Asset {
              lpImageTextUncropped {
                optimizedImageUrls
                srcset
                srcWebp
              }
              lpImageTextUncropped {
                optimizedImageUrls
              }
            }
          }
          linksMatrix2 {
            ... on linksMatrix2_entry_BlockType {
              buttonLabel
              ariaLabel
              entry {
                uri
              }
              openInANewWindow
            }
            ... on linksMatrix2_custom_BlockType {
              ariaLabel
              buttonLabel
              urlText
              openInANewWindow
            }
            ... on linksMatrix2_asset_BlockType {
              ariaLabel
              buttonLabel
              openInANewWindow
              asset {
                uri
              }
            }
            ... on linksMatrix2_productCategory_BlockType {
              ariaLabel
              buttonLabel
              productCategory {
                uri
              }
              openInANewWindow
            }
          }
        }
        ... on interactiveWebglDemo_interactiveWebGLDemo_Entry {
          promoTabStyle
          promoEyebrow
          promoCardStyle
          promoDescription
          promoTitle
          promoImage {
            ... on images_Asset {
              lpImageTextUncropped {
                optimizedImageUrls
                srcset
                srcWebp
              }
              lpImageTextUncropped {
                optimizedImageUrls
              }
            }
          }
          linksMatrix2 {
            ... on linksMatrix2_entry_BlockType {
              buttonLabel
              ariaLabel
              entry {
                uri
              }
              openInANewWindow
            }
            ... on linksMatrix2_custom_BlockType {
              ariaLabel
              buttonLabel
              urlText
              openInANewWindow
            }
            ... on linksMatrix2_asset_BlockType {
              ariaLabel
              buttonLabel
              openInANewWindow
              asset {
                uri
              }
            }
            ... on linksMatrix2_productCategory_BlockType {
              ariaLabel
              buttonLabel
              productCategory {
                uri
              }
              openInANewWindow
            }
          }
        }
      }
    }
    ... on bodyContent2022_textAndImage_BlockType {
      pageTitle
      displayInHeaderQuicklinks
      id
      image {
        __typename
        ... on images_Asset {
          url
          title
          lpImageTextUncropped {
            src
            srcWebp
            srcset
            optimizedImageUrls
          }
        }
        ... on svgIcons_Asset {
          url
          title
        }
        ... on videoUploads_Asset{
          title
          videoDescription
          videoDuration
          url
          image:videoThumbnail {
            ... on images_Asset {
              lpBackgroundWide {
                srcWebp
                srcset
              }
            }
          }
        }
        ... on videos_Asset{
          title
          lpBackgroundWide {
            srcWebp
            srcset
        }
        lpImageGridLandscape {
          srcWebp
          srcset
        }
        galleryEnlarged {
          srcWebp
          srcset
        }
        image:videoThumbnail {
          ... on images_Asset {
            lpBackgroundWide {
              srcWebp
              srcset
            }
          }
        }
        videoDuration
        videoId
        videoDescription
        }
      }
      backgroundVerticalPosition
      backgroundOpacity
      description
      typeHandle
      label
      layoutStyle
      ctaButton {
        ... on ctaButton_BlockType {
          asset {
            url
          }
          entry {
            uri
          }
          custom
          buttonStyling
          buttonLabel
          ariaLabel
          openInANewWindow
        }
      }
      colors
    }
    ... on bodyContent2022_videoPlayer_BlockType {
      typeHandle
      colors
      header
      text
      pageTitle
      displayInHeaderQuicklinks
      autoplay
      id
      videoDuration
      buttonText
      backgroundOverlayOpacity
      image {
        ... on landingPageVideos_Asset {
          id
          title
          videoId
          videoSource
          lpBackgroundWide {
            srcsetWebp
            srcset
          }
        }
        ... on images_Asset {
          title
          videoId
          videoSource
          lpImageTextUncropped {
            srcset
            srcWebp
          }
        }
        ... on videos_Asset {
          title
          videoId
          videoSource
          lpBackgroundWide {
            srcset
            srcWebp
          }
        }
      }
      backgroundVideo {
        id
        ... on videoUploads_Asset {
          url
          size
          extension
        }
        ... on videos_Asset {
          url
          size
          extension
        }
      }
    }
    ... on bodyContent2022_quoteSlider_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks
      id
      slides2 {
        ... on slides2_BlockType {
          enableQuote
          quote
          quoteAuthor
          descriptor
          workplace
          authorImage {
            ... on images_Asset {
              id
              aspectRatio11 {
                srcWebp
                srcset
              }
            }
          }
          button {
            url
            target
            customText
            ariaLabel
          }
        }
      }
      theme
      backgroundOverlayOpacity
      backgroundImage {
        ... on images_Asset {
          lpImageTextUncropped {
            srcset
            srcWebp
          }
        }
      }
    }
    ... on bodyContent2022_pageHeader_BlockType {
      typeHandle
      textAlignment
      displayInHeaderQuicklinks
      eyebrow
      pageTitle
      id
      subtitle
      text
      backgroundOverlayOpacity
      theme
      callToAction {
        ariaLabel
        customText
        target
        text
        title
        type
        url
          element {
            ... on videos_Asset {
              videoId
              title
              videoSource
            }
            id
          }
      }
      backgroundImage {
        __typename
        ... on images_Asset {
          lpImageTextUncropped {
            srcset
            srcWebp
          }
        }
        ... on videoUploads_Asset {
          url
        }
      }
    }
    ... on bodyContent2022_textContentCards_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks
      id
      roundedCorners
      moviePosters
      cardAssets {
        ... on images_Asset {
          cardDescription
          cardTitle
          title
          altText
          lpImageTextUncropped {
            srcWebp
            srcset
          }
          ${linksMatrixGql()}
        }
      }
    }
    ... on bodyContent2022_productOverviewGallery_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks
      id
      displayTitle
      displayThumbnailNav
      galleryAssets {
        ... on images_Asset {
          title
          caption
          galleryThumbnail {
            srcset
            srcWebp
          }
          galleryEnlarged {
            srcset
            srcWebp
          }
        }
        ... on videos_Asset {
          title
          caption
          videoId
          videoSource
          galleryThumbnail {
            srcset
            srcWebp
          }
          galleryEnlarged {
            srcset
            srcWebp
          }
        }
      }
    }
    ... on bodyContent2022_videoGallery_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks
      id
      videos {
        ... on videos_Asset {
          videoId
          videoSource
          videoType
          videoDescription
          videoGalleryTranscript
          videoDuration
          galleryEnlarged {
            srcWebp
            srcset
          }
          galleryThumbnail {
            srcWebp
            srcset
          }
        }
      }
    }
    ... on bodyContent2022_relatedResources_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks
      id
      displayFilter
      relatedResource {
        ... on pdfs_Asset {
          ${productTabRelatedResourcesGql}
        }
        ... on videos_Asset {
          ${productTabRelatedResourcesGql}
        }
        ... on images_Asset {
          ${productTabRelatedResourcesGql}
        }
        ... on zipFiles_Asset {
          ${productTabRelatedResourcesGql}
        }
      }
    }
    ... on bodyContent2022_productPageFeaturedProducts_BlockType {
      typeHandle
      pageTitle
      displayInHeaderQuicklinks:displayInQuicklinks
      id
      featuredProducts:productPageFeaturedProducts {
        ... on product_productPage2022_Entry {
          uri
          relatedProductTitle
          relatedProductDescriptor
          relatedProductDescription
          relatedProductImage {
            ... on images_Asset {
              lpImageGridMasonry {
                srcset
                srcWebp
              }
            }
          }
        }
        ... on product_productPage_Entry {
          uri
          relatedProductTitle
          relatedProductDescriptor
          relatedProductDescription
          relatedProductImage {
            ... on images_Asset {
              lpImageGridMasonry {
                srcWebp
                srcset
              }
            }
          }
        }
        ... on landingPage_landingPage2023_Entry {
          uri
          relatedProductTitle
          relatedProductDescription
          relatedProductDescriptor
          relatedProductImage {
            ... on images_Asset {
              lpImageGridMasonry {
                srcset
                srcWebp
              }
            }
          }
        }
      }
    }

    ... on bodyContent2022_basicText_BlockType {
      __typename
      typeHandle
      pageTitle
      textAlignment
      basicTextEyebrow
      description: productBasicTextDescription
      displayInHeaderQuicklinks
      id
      textBlocks:textBlocksProduct {
        ... on textBlocksProduct_BlockType {
          eyebrow
          subheader
          text
          textAlignment
          custom
          buttonLabel
          ariaLabel
          openInANewWindow
          primaryCtaBtn  {
            ariaLabel
            customText
            target
            text
            title
            type
            url
          }
          primaryCtaBtnLabel
          primaryCtaBtnAriaLabel
          primaryCtaBtnTheme
          primaryCtaBtnOpenInANewWindow
          secondaryButtonTheme
          entry {
            url
            title
          }
          asset {
            url
          }
          productCategory {
            url
          }
        }
      }
      columns
      colors
      buttons {
        buttonUrl
        buttonLabel
        openInANewTab
        buttonTheme
      }
    }
    ... on bodyContent2022_featuredContent_BlockType {
      typeHandle
      pageTitle
      header
      displayInHeaderQuicklinks
      id
      displayArticleSummary
      backgroundColor
      featuredContent {
        postDate
        title
        typeHandle
        ... on blog_blog_Entry {
          uri
          relatedEntryDescription
          blogFeaturedImage {
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
            ... on blogNews_Asset {
              filterPageFeaturedImage {
                srcWebp
                srcset
              }
            }
          }
          blogContent {
            ... on blogContent_text_BlockType {
              text
            }
          }
        }
        ... on pressRelease_pressRelease_Entry {
          uri
          relatedEntryDescription
          blogContent {
            ... on blogContent_text_BlockType {
              text
            }
          }
          blogFeaturedImage {
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
            ... on blogNews_Asset {
              filterPageFeaturedImage {
                srcWebp
                srcset
              }
            }
          }
        }
        ... on event_event_Entry {
          uri
          eventStartDateTime
          relatedEntryDescription
          eventFeaturedImage {
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
            ... on event_Asset {
              filterPageFeaturedImage {
                srcWebp
                srcset
              }
            }
          }
          eventsCategory {
            slug
          }
        }
        ... on event_eventV2_Entry {
          uri
          relatedEntryDescription
          eventFeaturedImage {
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
          }
          eventsCategory {
            slug
          }
        }
        ... on product_productPage_Entry {
          uri
          relatedEntryDescription
          productFeaturedImage {
            ... on productImages_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
          }
        }
        ... on product_productPage2022_Entry {
          uri
          relatedEntryDescription
          productFeaturedImage {
            ... on productImages_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
          }
        }
        ... on landingPage_landingPage_Entry {
          uri
          relatedEntryDescription
          landingPageFeaturedImage {
            ... on landingPageImages_Asset {
              lpImageGridLandscape {
                srcWebp
                srcset
              }
            }
            ... on images_Asset{
              title
              images:lpImageGridSquare {
                srcset
                srcsetWebp
              }
            }
          }
        }
        ... on landingPage_landingPage2023_Entry {
          uri
          relatedEntryDescription
          landingPageFeaturedImage {
            ... on landingPageImages_Asset {
              lpImageGridLandscape {
                srcWebp
                srcset
              }
            }
            ... on images_Asset{
              title
              images:lpImageGridSquare {
                srcset
                srcsetWebp
              }
            }
          }
        }
        ... on blog_customerStory_Entry {
          uri
          relatedEntryDescription
          blogFeaturedImage {
            ... on images_Asset {
              filterLandscape {
                srcWebp
                srcset
              }
            }
            ... on blogNews_Asset {
              filterPageFeaturedImage {
                srcWebp
                srcset
              }
            }
          }
        }
      }
    }
    ... on bodyContent2022_cSPromoBlock_BlockType {
      typeHandle
      displayTitle
      customerStoryStyle
      customerStory {
        ... on blog_customerStory_Entry {
          cardTitle
          cardDescription
          location
          customerStorySecondaryTitle
          customerStorySecondaryDescription
          uri
          customerStoryImage {
            ... on images_Asset {
              uncropped1920w {
                srcWebp
                srcset
                src
              }
            }
          }
        }
      }
    }
    ... on bodyContent2022_accordion_BlockType {
      typeHandle
      sectionTitle
      sectionDescription
      chip
      colors
      allowMultiple
      enableColumns:columns
      accordions {
        ... on accordions_BlockType {
          accordionDescription
          accordionTitle
          icon
          ctaLinks {
            openInANewTab
            linkUrl
            linkLabel
          }
        }
      }
    }
    ... on bodyContent2022_videoEmbed_BlockType {
      typeHandle
      embedStyle
      captionColor
      video {
          title
          __typename
          ... on videos_Asset {
              videoDuration
              videoId
              videoDescription
              caption
              image:lpBackgroundWide {
                  srcWebp
                  srcset
              }
          }
          ... on videoUploads_Asset {
              videoDescription
              caption
              videoDuration
              url
              videoThumbnail {
                  ... on images_Asset {
                      image:uncropped1920w {
                          srcWebp
                          srcset
                      }
                  }
              }
          }
      }
    }
    ${contentGridGql}
    ${imageGridGql}
    ${productHeaderGalleryGql}
    ${productHeaderPremiumGql}
    ${productHeaderStandardGql}
    ${textIconCardGql}
    ${relatedProductsGql}
    ${textContentCardsStandaloneGql}
  }
}

children(
  uri:":notempty:"
  limit: 6
) {
  id
  title
  typeHandle
  slug
  uri
  ${productTabCompareGql}
  ${productTabContentGql}
  ${productTabMultiColumnTableGql}
  ${productTabRelatedGql}
  ${productTabTableGql}
}
seomatic(asArray: true) {
  metaTitleContainer
  metaLinkContainer
  metaScriptContainer
  metaJsonLdContainer
  metaTagContainer
}`;

export const productGql = `query($fallbackUri: String, $site: String, $uri: String) {
  entry(
    section: ["product"]
    type: ["productPage", "productPage2022"]
    site: [$site]
    uri: [$uri]
    level: 1
  ) {
    ${pageGql}
  }
  fallbackEntry: entry(
    section: ["product"]
    type: ["productPage", "productPage2022"]
    site: [$site]
    uri: [$fallbackUri]
    level: 1
  ) {
    ${pageGql}
  }
}`;

export const productGenerateGql = function (sitesString = `$site`, params = {}) {
  const offset = params.offset || '0';
  const limit = params.limit || 'null';

  return `query {
    entryCount(
      uri:":notempty:"
      section: ["product"]
      type: ["productPage", "productPage2022"]
      site: [${sitesString}]
      limit: null
      level: 1
    )
    entries(
      uri:":notempty:"
      section: ["product"]
      type: ["productPage", "productPage2022"]
      site: [${sitesString}]
      offset: ${offset}
      limit: ${limit}
    ) {
      ${pageGql}
    }
  }`;
};
